<template>
<v-tooltip left
    v-if="phone_validation_chip_text() != 'Unknown'"
>
    <template v-slot:activator="{ on, attrs }">
        <v-chip
            :style="phone_validation_chip_style()" 
            v-bind="attrs"
            v-on="on"
            
        >
            {{phone_validation_chip_text()}}
        </v-chip>
    </template>
    <span>
        <m-phone-number-validation-data
            :value="value.orig_result"
        />
    </span>
</v-tooltip>
</template>

<script>
export default 
{
    props: {
        value: {
            type: Object,
            default: null
        },
    },

    methods: {
        phone_validation_chip_text()
        {
            let item = this.value;

            if ( item == null || item.orig_result == null || item.orig_result.validation_line_type == null )
                return "Unknown";

            if ( (''+item.orig_result.validation_network_name).toLowerCase().includes("redchirp")  )
                return "RedChirp";

            if ( item.orig_result.validation_line_type == 'domestic-mobile' )
                return "Mobile";

            if ( item.orig_result.validation_line_type == 'domestic-landline' )
                return "Landline";

            if ( item.orig_result.validation_line_type == 'domestic-invalid' )
                return "Not in service";

            if ( item.orig_result.validation_line_type == 'international-unknown' )
                return "International";
            
            return "Unknown";
        },

        phone_validation_chip_style()
        {
            let label = this.phone_validation_chip_text();

            if ( label == 'Mobile' || label == 'RedChirp' )
                return 'background-color: #75EABD; color: white; cursor: pointer';

            if ( label == 'Not in service' )
                return 'background-color: rgba(255,0,0,0.3); color: white; cursor: pointer';


            return 'cursor: pointer; color: rgba(0,0,0,0.3)';
        },
    },
}
</script>

<style lang="scss" scoped>

</style>